module.exports = __webpack_public_path__ + "img/20190611_113036_016.2154679d.jpg";